import {useQuery} from "@tanstack/react-query";
import {DnaService} from "../../services/dna-service";
import {InfoBox} from "../Common/alerts";
import {List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {FilePresent} from "@mui/icons-material";
import React from "react";

export const DnaResults = ({animalId}: { animalId: string }) => {
    const {data = [], isPending} = useQuery({
        queryKey: ['dna', {animalId}],
        queryFn: async () => await DnaService.queryDnaResults(animalId),
    });

    if (!isPending && data.length === 0) {
        return (
            <InfoBox>Keine DNA-Ergebnisse vorhanden</InfoBox>
        );
    }

    const formatMarkers = (markers: string[]) => {
        const names = [
            'LCA19',
            'LCA37',
            'LCA5',
            'LCA56',
            'LCA65',
            'LCA66',
            'LCA8',
            'LCA94',
            'LCA99',
            'LGU49',
            'LGU50',
            'YWLL29',
            'YWLL40',
            'YWLL44',
        ];
        const value = (marker: string) => marker !== '' ? marker : '---';
        return markers
            .slice(0, 28)
            .flatMap((_, i, a) => i % 2 ? [] : [a.slice(i, i + 2)])
            .map((pair, idx) => [names[idx], pair])
            .map(([name, pair]) => `${(name + ':    ').slice(0, 8)}\t${value(pair[0])} | ${value(pair[1])}`)
            .join('\n');
    }

    return (
        <List>
            {data.map(dna => (
                <ListItemButton key={dna.labNumber}
                                onClick={() => window.alert(`DNA-Ergebnis (ISAG):\n\n${formatMarkers(dna.markers)}`)}>
                    <ListItemIcon><FilePresent/></ListItemIcon>
                    <ListItemText secondary={dna.testDate.toLocaleString()}>{dna.labNumber}</ListItemText>
                </ListItemButton>
            ))}
        </List>
    );
};